import { render, staticRenderFns } from "./tzgg.vue?vue&type=template&id=07f88eae&scoped=true"
import script from "./tzgg.vue?vue&type=script&lang=js"
export * from "./tzgg.vue?vue&type=script&lang=js"
import style0 from "./tzgg.vue?vue&type=style&index=0&id=07f88eae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f88eae",
  null
  
)

export default component.exports